module.exports = ".task {\n  color: #fff;\n  text-transform: capitalize;\n  line-height: 60px;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  .task a {\n    color: #fff; }\n  .task.status-46205 {\n    background-color: #2196f3; }\n  .task.status-46206 {\n    background-color: #f44336; }\n  .task.status-46453 {\n    background-color: #4caf50; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/task/task.component.scss
// module id = ./src/app/stage/components/task/task.component.scss
// module chunks = main